import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, hasPermission, hasAnyPermission } from "../context/AuthContext";
import { permissionForPath } from "../lib/permissions";
import { homePathForRole } from "../lib/dashboardRole";

export default function PermissionRoute({ children, permission }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const required = permission || permissionForPath(location.pathname);

  if (loading) {
    return (
      <div className="min-h-[40vh] grid place-items-center text-sm text-muted-foreground">Loading…</div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const allowed = !required
    || (Array.isArray(required) ? hasAnyPermission(user, required) : hasPermission(user, required));
  if (!allowed) {
    return <Navigate to={homePathForRole(user.role)} replace />;
  }

  return children;
}
